import type { PropsWithChildren } from 'react'
import { createContext, useContext, useState } from 'react'

export type SharePanelViewView = 'initial' | 'embed' | 'qrcode'

export interface SharePanelContextValue {
  view: SharePanelViewView
  setView: (next: SharePanelViewView) => void
  str: () => string
  reset: () => void
}

export const SharePanelContext = createContext<SharePanelContextValue | null>(
  null
)

export function SharePanelProvider(props: PropsWithChildren) {
  const [view, setView] = useState<SharePanelViewView>('initial')

  return (
    <SharePanelContext.Provider
      value={{ view, str, reset, setView: next => setView(next) }}
    >
      {props.children}
    </SharePanelContext.Provider>
  )

  function reset() {
    setView('initial')
  }

  function str(): string {
    switch (view) {
      case 'embed':
        return 'Embed'
      case 'qrcode':
        return 'QR Code'
      case 'initial':
      default:
        return 'Share to...'
    }
  }
}

export function useSharePanelContext() {
  const value = useContext(SharePanelContext)
  if (!value) {
    throw new Error('Missing SharePanelProvider')
  }
  return value
}
